"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Check = require("../icon/Check");

var _Check2 = _interopRequireDefault(_Check);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Option = function Option(props) {
  var children = props.children,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isSelected = props.isSelected;
  return _react2.default.createElement("div", _extends({
    style: getStyles('option', props),
    ref: innerRef
  }, innerProps), _react2.default.createElement("div", {
    className: "flex"
  }, isMulti ? null : _react2.default.createElement("span", {
    className: "flex self-center pr3 w1"
  }, isSelected ? _react2.default.createElement(_Check2.default, null) : null), children));
};

exports.default = Option;